import { render, staticRenderFns } from "./BaseSlide.vue?vue&type=template&id=2bc60aef&scoped=true&"
import script from "./BaseSlide.vue?vue&type=script&lang=js&"
export * from "./BaseSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc60aef",
  null
  
)

export default component.exports